import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { CalcCopyFromParams } from '../../orderline-calc-form/orderline-calc-form.service';

@Component({
    selector: 'tt-calc-copy-from-view',
    templateUrl: './calc-copy-from-view.component.html',
    styleUrls: ['./calc-copy-from-view.component.css'],
})
export class CalcCopyFromViewComponent {
    public params: CalcCopyFromParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as CalcCopyFromParams;
    }
}
